import { render, staticRenderFns } from "./DashboardBox.vue?vue&type=template&id=77657599&scoped=true&"
import script from "./DashboardBox.vue?vue&type=script&lang=ts&"
export * from "./DashboardBox.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBox.vue?vue&type=style&index=0&id=77657599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77657599",
  null
  
)

export default component.exports